const SCRIPT_RE = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
const EVENT_ATTR_RE = /\bon\w+\s*=\s*(['"]).*?\1/gi;
const NULL_BYTE_RE = /\0/g;

export function sanitizeString(input: string): string {
    return input
        .replace(NULL_BYTE_RE, '')
        .replace(SCRIPT_RE, '')
        .replace(EVENT_ATTR_RE, '')
        .trim();
}

export function sanitizeObject<T extends Record<string, unknown>>(obj: T): T {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
            key,
            typeof value === 'string' ? sanitizeString(value) : value,
        ])
    ) as T;
}
